module.exports = __webpack_public_path__ + "static/media/item-accounts-active.9e754983.svg";